import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(duration);
dayjs.extend(relativeTime);

// IMPORTANT: this utils file is used to encapsulate dayjs
export function getHumanReadableRemainingTime(startDate: string, period: number = 1, unit: dayjs.ManipulateType = 'months'): string {
    const start = dayjs(startDate);
    const current = dayjs();
    const end = dayjs(start).add(period, unit);
    return dayjs.duration(end.diff(current)).humanize(true);
}

export function getLeftNumberOfDays(startDate: dayjs.Dayjs, endDate: dayjs.Dayjs): number {
    return Math.round(dayjs.duration(endDate.diff(startDate)).asDays() as number);
}

export function getNewDateFormatted(format: string, date?: string): string {
    return date ? getNewDate(date).format(format) : getNewDate().format(format);
}

export function getNewDate(date?: string | number | Date | dayjs.Dayjs | null | undefined): dayjs.Dayjs {
    return date ? dayjs(date) : dayjs();
}

export function extendDate(
    date?: string | number | Date | dayjs.Dayjs | null | undefined,
    period: number = 1,
    unit: dayjs.ManipulateType = 'year',
): dayjs.Dayjs {
    return dayjs(date).add(period, unit);
}

export function subtractDate(
    date?: string | number | Date | dayjs.Dayjs | null | undefined,
    period: number = 1,
    unit: dayjs.ManipulateType = 'year',
): dayjs.Dayjs {
    return dayjs(date).subtract(period, unit);
}

export function convertToMinutes(seconds: number): number {
    return Math.round(dayjs.duration({ seconds }).asMinutes());
}
